var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-increase-indicator",class:{
    increasing: _vm.increasing,
    decreasing: _vm.decreasing,
    stable: _vm.stable,
    inversed: _vm.inversed,
    'no-background': _vm.noBackground
  }},[_c('v-icon',{staticClass:"indicator"},[_vm._v(_vm._s(_vm.icon))]),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.floatValue ? Math.abs(_vm.value.toFixed(1)) : Math.abs(_vm.value.toFixed(0)))+_vm._s(_vm.showUnit ? _vm.unit : ""))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }